import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31a98f02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "course" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "name" }, "C2OPS")
], -1))
const _hoisted_3 = { class: "list" }
const _hoisted_4 = {
  key: 0,
  class: "selected-border"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "details" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "Start Date", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "Grad. Date", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "Class Code", -1))
const _hoisted_12 = { class: "value" }

import IconComponent from '../icon/IconComponent.vue';
import Icon from '../icon/Icon';
import { Class } from '../../models/Class';
import { formatDate_DD_MMM_YY_DASHES } from '@/utils/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassListWidget',
  props: {
    classes: null,
    selectedClass: null
  },
  emits: ["itemClick"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'itemClick', arg1: Class): void;
}), expose: any, slots: any, attrs: any }) {





const handleItemClick = (item: Class) => {
  emits('itemClick', item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.classes, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "item",
            key: index
          }, [
            (item.id === __props.selectedClass?.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["header", { selectedClassHeader: item.id === __props.selectedClass?.id }]),
              onClick: ($event: any) => (handleItemClick(item))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["name", { selectedClassName: item.id === __props.selectedClass?.id }])
              }, " Class " + _toDisplayString(item.name), 3),
              _createVNode(IconComponent, {
                icon: 
                item.id === __props.selectedClass?.id ? _unref(Icon).RED_X : _unref(Icon).VISIBILITY
              
              }, null, 8, ["icon"])
            ], 10, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _hoisted_7,
                _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(formatDate_DD_MMM_YY_DASHES)(item.startDate)), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_9,
                _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(formatDate_DD_MMM_YY_DASHES)(item.endDate)), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_11,
                _createElementVNode("p", _hoisted_12, _toDisplayString(item.inviteCode), 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})